'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _keys = require('babel-runtime/core-js/object/keys');

var _keys2 = _interopRequireDefault(_keys);

var _objectWithoutProperties2 = require('babel-runtime/helpers/objectWithoutProperties');

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _regenerator = require('babel-runtime/regenerator');

var _regenerator2 = _interopRequireDefault(_regenerator);

exports.patchFlight = patchFlight;

var _lodash = require('lodash');

var _lodash2 = _interopRequireDefault(_lodash);

var _effects = require('redux-saga/effects');

var _utilityFunctions = require('utils/utilityFunctions');

var _forms = require('utils/forms');

var _apiHelper = require('api/api-helper');

var _profilesDataActions = require('actions/profilesDataActions');

var _requirementDataActions = require('actions/requirementDataActions');

var _deprecatedFlightStatusActions = require('actions/deprecatedFlightStatusActions');

var _resourcesActions = require('actions/resourcesActions');

var _triggerFlightSegmentValidation = require('./triggerFlightSegmentValidation');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _marked = /*#__PURE__*/_regenerator2.default.mark(patchFlight),
    _marked2 = /*#__PURE__*/_regenerator2.default.mark(updateResources);

// gapiBaseURL is a global (defined with webpack's definePlugin)

function patchFlight(flightHref, flight, authToken) {
    var flightPatchResult, deprecatedFlights, _ref, error, patchSucceededResource, postFlightHref, newPostedFlight;

    return _regenerator2.default.wrap(function patchFlight$(_context) {
        while (1) {
            switch (_context.prev = _context.next) {
                case 0:
                    if (!(flight.segments.length === 1 && (0, _utilityFunctions.isAllNullish)(flight.segments[0]))) {
                        _context.next = 7;
                        break;
                    }

                    _context.next = 3;
                    return (0, _effects.call)(_apiHelper.patchResource, flightHref, { state: 'CANCELLED' }, authToken);

                case 3:
                    flightPatchResult = _context.sent;
                    return _context.abrupt('return', flightPatchResult);

                case 7:
                    _context.next = 9;
                    return (0, _effects.select)(function (state) {
                        return state.apiCalls.deprecatedFlights;
                    });

                case 9:
                    deprecatedFlights = _context.sent;

                    if (deprecatedFlights.includes(flightHref)) {
                        _context.next = 22;
                        break;
                    }

                    _context.next = 13;
                    return (0, _effects.call)(_apiHelper.patchResource, flightHref, { state: 'DEPRECATED' }, authToken);

                case 13:
                    _ref = _context.sent;
                    error = _ref.error;
                    patchSucceededResource = _ref.patchSucceededResource;

                    if (!(error || patchSucceededResource && patchSucceededResource.errors)) {
                        _context.next = 20;
                        break;
                    }

                    return _context.abrupt('return', { patchSucceededResource: patchSucceededResource, error: error });

                case 20:
                    _context.next = 22;
                    return (0, _effects.put)((0, _deprecatedFlightStatusActions.deprecatedFlightStatusAdded)(flightHref));

                case 22:

                    // if no error, or if already deprecated, continue with the POST of the flight to replace the old one
                    postFlightHref = flightHref.slice(0, flightHref.indexOf('/flight_statuses/') + 17);
                    _context.next = 25;
                    return (0, _effects.call)(_apiHelper.postResource, postFlightHref, flight, authToken);

                case 25:
                    newPostedFlight = _context.sent;


                    // pretend this was a PATCH all along
                    newPostedFlight.patchSucceededResource = newPostedFlight.postSucceededResource;
                    delete newPostedFlight.postSucceededResource;

                    if (newPostedFlight.error || newPostedFlight.patchSucceededResource && newPostedFlight.patchSucceededResource.errors) {
                        _context.next = 31;
                        break;
                    }

                    _context.next = 31;
                    return (0, _effects.put)((0, _deprecatedFlightStatusActions.deprecatedFlightStatusOverwritten)(flightHref));

                case 31:
                    return _context.abrupt('return', newPostedFlight);

                case 32:
                case 'end':
                    return _context.stop();
            }
        }
    }, _marked, this);
}

function updateResources() {
    var _this = this;

    var _loop;

    return _regenerator2.default.wrap(function updateResources$(_context3) {
        while (1) {
            switch (_context3.prev = _context3.next) {
                case 0:
                    _loop = /*#__PURE__*/_regenerator2.default.mark(function _loop() {
                        var _ref2, payload, toPost, toDelete, toPatch, authToken, shouldRefreshReqs, patchedResourceHrefs, patchedResources, postedResources, postedResourcePaths, deletedResources, patchSucceededProfiles, errors, wereErrors;

                        return _regenerator2.default.wrap(function _loop$(_context2) {
                            while (1) {
                                switch (_context2.prev = _context2.next) {
                                    case 0:
                                        _context2.next = 2;
                                        return (0, _effects.take)(_resourcesActions.RESOURCES_UPDATE_REQUESTED);

                                    case 2:
                                        _ref2 = _context2.sent;
                                        payload = _ref2.payload;
                                        toPost = payload.toPost, toDelete = payload.toDelete, toPatch = (0, _objectWithoutProperties3.default)(payload, ['toPost', 'toDelete']);
                                        _context2.next = 7;
                                        return (0, _effects.select)(function (state) {
                                            return state.user.authorization.token;
                                        });

                                    case 7:
                                        authToken = _context2.sent;
                                        shouldRefreshReqs = false;
                                        // PATCH

                                        patchedResourceHrefs = (0, _keys2.default)(toPatch).map(function (resourceHref) {
                                            return resourceHref;
                                        });
                                        _context2.next = 12;
                                        return patchedResourceHrefs.map(function (resourceHref) {
                                            // Flights
                                            if (resourceHref.includes('/flight_statuses/')) {
                                                return (0, _triggerFlightSegmentValidation.handleToPatchFlightStatusRequest)(resourceHref, toPatch[resourceHref], authToken);
                                            } else {
                                                return (0, _effects.call)(_apiHelper.patchResource, resourceHref, toPatch[resourceHref], authToken);
                                            }
                                        });

                                    case 12:
                                        patchedResources = _context2.sent;


                                        // POST
                                        postedResources = [];
                                        postedResourcePaths = [];

                                        if (!toPost) {
                                            _context2.next = 19;
                                            break;
                                        }

                                        _context2.next = 18;
                                        return _lodash2.default.flatMap((0, _keys2.default)(toPost), function (resourceHref) {
                                            return (0, _keys2.default)(toPost[resourceHref]).map(function (tempId) {
                                                postedResourcePaths.push('toPost[\'' + resourceHref + '\'].' + tempId);
                                                if (resourceHref.includes("flight_statuses")) {
                                                    return (0, _triggerFlightSegmentValidation.handleToPostFlightStatusRequest)(toPost, resourceHref, tempId, authToken);
                                                }
                                                return (0, _effects.call)(_apiHelper.postResource, resourceHref, toPost[resourceHref][tempId], authToken);
                                            });
                                        });

                                    case 18:
                                        postedResources = _context2.sent;

                                    case 19:
                                        // DELETE
                                        deletedResources = [];

                                        if (!toDelete) {
                                            _context2.next = 24;
                                            break;
                                        }

                                        _context2.next = 23;
                                        return toDelete.map(function (resourceHref) {
                                            return (0, _effects.call)(_apiHelper.deleteResource, resourceHref, authToken);
                                        });

                                    case 23:
                                        deletedResources = _context2.sent;

                                    case 24:
                                        // profiles
                                        patchSucceededProfiles = [];

                                        // errors._error flags the user of an error that occured not from bad syntax (400, 424, etc.),
                                        //  but rather an error that is out of their control (server error, authentication error, etc.)

                                        errors = { _error: false };


                                        patchedResources.forEach(function (patchedResource, i) {
                                            var patchedErrorCode = _lodash2.default.get(patchedResource, 'error.errors[0].code');
                                            if (patchedErrorCode && !errors._error) {
                                                errors = (0, _extends3.default)({}, errors, {
                                                    _error: patchedErrorCode
                                                });
                                            }

                                            if (!patchedResource) return;
                                            var fieldPath = '[\'' + patchedResourceHrefs[i] + '\']';
                                            var patchSucceededResource = patchedResource.patchSucceededResource,
                                                error = patchedResource.error,
                                                flightSegmentErrorCode = patchedResource.flightSegmentErrorCode;


                                            if (flightSegmentErrorCode) {
                                                errors = (0, _forms.updateErrorsObject)({ fieldPath: fieldPath, error: { _error: true }, errors: errors, genErrorCode: flightSegmentErrorCode });
                                            } else if (error) {
                                                errors = (0, _forms.updateErrorsObject)({ fieldPath: fieldPath, error: error, errors: errors });
                                            } else {
                                                shouldRefreshReqs = true;
                                            }

                                            // Check for profiles PATCHes (we treat these differently because we don't
                                            //  get them back in the `requirements` refresh)
                                            if (fieldPath.includes(gapiBaseURL + '/profiles/') && !error) {
                                                patchSucceededProfiles.push(patchSucceededResource);
                                            }
                                        });

                                        postedResources.forEach(function (postedResource, i) {
                                            var postedErrorCode = _lodash2.default.get(postedResource, 'error.errors[0].code');
                                            if (postedErrorCode && !errors._error) {
                                                errors = (0, _extends3.default)({}, errors, {
                                                    _error: postedErrorCode
                                                });
                                            }

                                            if (!postedResource) return;
                                            var fieldPath = postedResourcePaths[i];
                                            var error = postedResource.error,
                                                flightSegmentErrorCode = postedResource.flightSegmentErrorCode;
                                            // const { postSucceededResource } = postedResource

                                            if (flightSegmentErrorCode) {
                                                errors = (0, _forms.updateErrorsObject)({ fieldPath: fieldPath, error: { _error: true }, errors: errors, genErrorCode: flightSegmentErrorCode });
                                            } else if (error) {
                                                errors = (0, _forms.updateErrorsObject)({ fieldPath: fieldPath, error: error, errors: errors });
                                            } else {
                                                shouldRefreshReqs = true;
                                            }
                                        });

                                        deletedResources.forEach(function (deletedResource) {
                                            if (!deletedResource) return;
                                            var error = deletedResource.error;
                                            // const { deleteSucceededResource } = deletedResource

                                            if (error) {
                                                errors = (0, _forms.updateErrorsObject)({ error: error, errors: errors });
                                            } else {
                                                shouldRefreshReqs = true;
                                            }
                                        });

                                        wereErrors = errors._error || (0, _keys2.default)(errors).length > 1;

                                        if (!wereErrors) {
                                            _context2.next = 35;
                                            break;
                                        }

                                        _context2.next = 33;
                                        return (0, _effects.put)((0, _resourcesActions.resourcesUpdateFailed)(errors));

                                    case 33:
                                        _context2.next = 37;
                                        break;

                                    case 35:
                                        _context2.next = 37;
                                        return (0, _effects.put)((0, _resourcesActions.resourcesUpdateSucceeded)());

                                    case 37:
                                        if (!(patchSucceededProfiles.length > 0)) {
                                            _context2.next = 40;
                                            break;
                                        }

                                        _context2.next = 40;
                                        return (0, _effects.put)((0, _profilesDataActions.profilesUpdateSucceeded)(patchSucceededProfiles));

                                    case 40:
                                        if (!(shouldRefreshReqs && !wereErrors)) {
                                            _context2.next = 43;
                                            break;
                                        }

                                        _context2.next = 43;
                                        return (0, _effects.put)((0, _requirementDataActions.requirementDataRequested)());

                                    case 43:
                                    case 'end':
                                        return _context2.stop();
                                }
                            }
                        }, _loop, _this);
                    });

                case 1:
                    if (!true) {
                        _context3.next = 5;
                        break;
                    }

                    return _context3.delegateYield(_loop(), 't0', 3);

                case 3:
                    _context3.next = 1;
                    break;

                case 5:
                case 'end':
                    return _context3.stop();
            }
        }
    }, _marked2, this);
}

exports.default = updateResources;


//////////////////
// WEBPACK FOOTER
// ./app/sagas/updateResources.js
// module id = 637
// module chunks = 0